export const STUDIES_PATH = '/insight/impact-analytics/studies';

export const BASE_CRUMBS = [{ label: 'Insights' }, { label: 'Impact Analytics' }];

export const DETAIL_CRUMBS = [...BASE_CRUMBS, { label: 'Studies', to: STUDIES_PATH }];

export function goBack(router) {
  if (window.history.state && window.history.state.back) router.back();
  else router.push(STUDIES_PATH);
}
